// extracted by mini-css-extract-plugin
export default {"container":"Home_container__cF+Wd","video":"Home_video__CxJll","sections":"Home_sections__-5DNE","picture":"Home_picture__Utrem"};